var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocument(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "-0.645 -0.645 18 18",
    height: 18,
    width: 18,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.29
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 1.6h5.8l3.8 3.8v9.1a1.3 1.3 0 0 1 -1.3 1.3H4a1.3 1.3 0 0 1 -1.3 -1.3V2.9a1.3 1.3 0 0 1 1.3 -1.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.8 1.6v3.8h3.8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.7 9.3h5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.7 12.1h5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocument);
export default __webpack_public_path__ + "static/media/document.af043ab035fe267ca2580a00f9ead245.svg";
export { ForwardRef as ReactComponent };